import { FileCenterItemTooltip } from "@/components/file_viewer/fileCenterTooltips";
import { cn } from "@/lib/utils";

/** Radix ScrollArea's inner wrapper defaults to display:table, which expands to fit long labels. */
export const FILE_CENTER_SIDEBAR_SCROLL_VIEWPORT_CLASS =
  "overflow-x-hidden !max-w-full [&>div]:!block [&>div]:!w-full [&>div]:!min-w-0 [&>div]:!max-w-full [&>div]:!overflow-x-hidden";

type FileCenterSidebarLabelProps = {
  text: string;
  className?: string;
};

/**
 * Sidebar tree labels: single-line ellipsis in a fixed-width column.
 * Uses native title for full text (Radix tooltips fight truncation inside ScrollArea).
 */
export function FileCenterSidebarLabel({ text, className }: FileCenterSidebarLabelProps) {
  return (
    <div className="min-w-0 flex-1 overflow-hidden">
      <span className={cn("block truncate text-left", className)} title={text}>
        {text}
      </span>
    </div>
  );
}

type FileCenterTruncatedTextProps = {
  text: string;
  className?: string;
  tooltipSide?: "top" | "right";
};

/** Single-line ellipsis with tooltip for center browse list rows. */
export function FileCenterTruncatedText({
  text,
  className,
  tooltipSide = "top",
}: FileCenterTruncatedTextProps) {
  return (
    <div className="min-w-0 flex-1 overflow-hidden">
      <FileCenterItemTooltip label={text} side={tooltipSide}>
        <span className={cn("block w-full truncate text-left", className)} title={text}>
          {text}
        </span>
      </FileCenterItemTooltip>
    </div>
  );
}

type FileCenterGridLabelProps = {
  label: string;
  className?: string;
};

/** Truncated label for folder/file rows in the center browse list. */
export function FileCenterGridLabel({ label, className }: FileCenterGridLabelProps) {
  return (
    <FileCenterTruncatedText
      text={label}
      className={cn("text-sm font-medium", className)}
    />
  );
}
